export const settingConfig = {

  applicationTab: [
    {
      key: 'Type',
      value: 1
    },
    {
      key: 'Location',
      value: 2
    },
    {
      key: 'Applicant',
      value: 3
    },
    {
      key: 'Ownership',
      value: 4
    },
    {
      key: 'Premises',
      value: 5
    },
    {
      key: 'Acknowledgement',
      value: 6
    },
    {
      key: 'Review',
      value: 7
    }
  ],
  type: {
    typeOfApplication: [
      {
        key: 'Standard License',
        value: 1
      },
      {
        key: 'Micro License',
        value: 2
      },
      {
        key: 'Safety Compliance',
        value: 3
      }
    ],

    typeOfLicense: [
      {
        key: 'Cultivation',
        value: 1
      },
      {
        key: 'Manufacturer',
        value: 2
      },
      {
        key: 'Wholesaler',
        value: 3
      },
      {
        key: 'Distributor',
        value: 4
      },
      {
        key: 'Retailer',
        value: 5
      },
      {
        key: 'Delivery',
        value: 6
      },
      {
        key: 'Safety Compliance',
        value: 7
      }
    ],
    standardLicenseType: [
      {
        key: 'Stacked Grower',
        value: 1
      },
      {
        key: 'Consumption',
        value: 2
      },
      // {
      //   key: 'terms',
      //   value: 2
      // },
      // {
      //   key: 'Consumption',
      //   value: 4
      // },
      // {
      //   key: 'Stacked Grower',
      //   value: 5
      // },
      // {
      //   key: 'Consumption',
      //   value: 6
      // },
      // {
      //   key: 'Stacked Grower',
      //   value: 7
      // },
      // {
      //   key: 'Consumption',
      //   value: 8
      // },
      // {
      //   key: 'Stacked Grower',
      //   value: 9
      // },
      // {
      //   key: 'Consumption',
      //   value: 10
      // },
      // {
      //   key: 'Stacked Grower',
      //   value: 11
      // },
      // {
      //   key: 'Consumption',
      //   value: 12
      // }
    ]
  },


  location: {
    locationType: [
      {
        key: 'Yes',
        value: 1
      },
      {
        key: 'No',
        value: 2
      },
      // {
      //   key: 'Mixed Use',
      //   value: 3
      // }
    ],
    zipCodebusiness: [
      {
        key: 'Yes',
        value: 1
      },
      {
        key: 'No',
        value: 2
      },

    ],
    zipCode: [
      {
        key: '07101',
        value: 1
      },
      {
        key: '07102',
        value: 2
      },
      {
        key: '07103',
        value: 3
      },
      {
        key: '07104',
        value: 4
      },
      {
        key: '07105',
        value: 5
      },
      {
        key: '07106',
        value: 6
      },
      {
        key: '07107',
        value: 7
      },
      {
        key: '07108',
        value: 8
      },

      {
        key: '07112',
        value: 9
      },
      {
        key: '07114',
        value: 10
      },
      {
        key: '07175',
        value: 11
      },
      {
        key: '07184',
        value: 12
      },
      {
        key: '07188',
        value: 13
      },
      {
        key: '07189',
        value: 14
      },
      {
        key: '07191',
        value: 15
      },
      {
        key: '07192',
        value: 16
      },
      {
        key: '07193',
        value: 17
      },
      {
        key: '07195',
        value: 18
      },
      {
        key: '07198',
        value: 19
      },
      {
        key: '07199',
        value: 20
      },



    ],
    terminal: [
      {
        key: 'Terminal A',
        value: 1
      },
      {
        key: 'Terminal B',
        value: 2
      },
      {
        key: 'Terminal C',
        value: 3
      },

    ],
  },
  applicant: {
    type: [
      {
        key: 'Business owner',
        value: 1
      },
      {
        key: 'Accountant',
        value: 2
      },
      {
        key: 'Staff',
        value: 3
      },
      {
        key: 'Attorney',
        value: 4
      },
      {
        key: 'Other',
        value: 5
      }
    ],
    businessType: [
      {
        key: 'Corporation',
        value: 1
      },
      {
        key: 'LLC',
        value: 2
      },
      {
        key: 'Partnership',
        value: 3
      }
    ],
    bonusPoints: [
      {
        key: 'Yes',
        value: 1
      },
      {
        key: 'No',
        value: 2
      }
    ],

  },

  ownership: {
    role: [
      {
        key: "Owner",
        value: 1
      },
      {
        key: "Officer",
        value: 2
      }
    ]
  },
  premises: {
    samePropertyOwner: [
      {
        key: "Yes",
        value: 1
      },
      {
        key: "No",
        value: 2
      }
    ]
  },
  Days: {
    dropdownList: [
      { value: 1, key: 'Mon' },
      { value: 2, key: 'Tues' },
      { value: 3, key: 'Wed' },
      { value: 4, key: 'Thur' },
      { value: 5, key: 'Fri' },
      { value: 6, key: 'Sat' },
      { value: 7, key: 'Sun' },
    ]
  },
  acknowledgement: {
    acknowledgementRules: [
      {
        key: 'I affirm and certify that all the information and answers to questions herein are complete, true and correct to the best of my knowledge and belief. I understand that any misrepresentation, falsification, may delay my application or lead to the revocation of my license.',
        value: 'acknowledge_1'
      },
      {
        key: '',
        value: 'acknowledge_2'
      },
      {
        key: 'I understand that a business license can not be issued with a current and valid Trade Waste, Health, or Fire permit where applicable.',
        value: 'acknowledge_3'
      },
      // {
      //   key: 'I acknowledge that my workforce must be a part of a collective bargaining agreement (unionized) unless I am operating a microbusiness.',
      //   value: 'terms_4'
      // },
      // {
      //   main_content: 'I certify that I have read and understood that accompany this application. By checking the box below, I understand that I am providing my electronic signature to this application for filing. With this electronic signature, I attest under penalty of perjury that I am an authorized signature for the entity I represent and/or authorize to submit the application on behalf of the entity, I hereby declare that the information contained within and submitted with the application is complete, true and accurate. I understand that a misrepresentation of fact is cause for rejection of the application, denial of the license, and revocation of a license issued.',
      //   key: 'By checking this box, I agree to the above certification.',
      //   value: 'terms_5'
      // },
      // {
      //   key: 'I acknowledge cannabis policy liberalization provides opportunities for therapeutic benefit but also presents the potential for health harms',
      //   value: 'terms_3'
      // }
    ]
  },
  addLicness: {
    feeTypeList: [
      {
        key: "Standard",
        value: 1
      },
      {
        key: "Calculated",
        value: 2
      }
    ]
  },

  ein: {
    haveU: [
      {
        key: "Yes",
        value: 1
      },
      {
        key: "No",
        value: 2
      }
    ]
  },

  business: {
    haveU: [
      {
        key: "Yes",
        value: 1
      },
      {
        key: "No",
        value: 2
      }
    ],
    type: [
      {
        key: "Vacant Property",
        value: 1
      },
      {
        key: "Multiple Dwelling",
        value: 2
      }
    ],
    type_of_business: [
      {
        key: "Vacant Property",
        value: 1
      },
      {
        key: "Multiple Dwelling",
        value: 2
      }
    ],

    Business_cycle: [
      {
        key: "Seasonal",
        value: 1
      },
      {
        key: "Year round",
        value: 2
      }
    ]
  },
  statesOfUS: [
    "Alaska",
    "Alabama",
    "Arkansas",
    "American Samoa",
    "Arizona",
    "California",
    "Colorado",
    "Connecticut",
    "District of Columbia",
    "Delaware",
    "Florida",
    "Georgia",
    "Guam",
    "Hawaii",
    "Iowa",
    "Idaho",
    "Illinois",
    "Indiana",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Massachusetts",
    "Maryland",
    "Maine",
    "Michigan",
    "Minnesota",
    "Missouri",
    "Mississippi",
    "Montana",
    "North Carolina",
    "North Dakota",
    "Nebraska",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "Nevada",
    "New York",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Virginia",
    "Virgin Islands",
    "Vermont",
    "Washington",
    "Wisconsin",
    "West Virginia",
    "Wyoming"
  ],
  citiesOfUS: [
    "Aberdeen", "Abilene", "Akron", "Albany", "Albuquerque", "Alexandria", "Allentown", "Amarillo", "Anaheim", "Anchorage", "Ann Arbor", "Antioch", "Apple Valley", "Appleton", "Arlington", "Arvada", "Asheville", "Athens", "Atlanta", "Atlantic City", "Augusta", "Aurora", "Austin", "Bakersfield", "Baltimore", "Barnstable", "Baton Rouge", "Beaumont", "Bel Air", "Bellevue", "Berkeley", "Bethlehem", "Billings", "Birmingham", "Bloomington", "Boise", "Boise City", "Bonita Springs", "Boston", "Boulder", "Bradenton", "Bremerton", "Bridgeport", "Brighton", "Brownsville", "Bryan", "Buffalo", "Burbank", "Burlington", "Cambridge", "Canton", "Cape Coral", "Carrollton", "Cary", "Cathedral City", "Cedar Rapids", "Champaign", "Chandler", "Charleston", "Charlotte", "Chattanooga", "Chesapeake", "Chicago", "Chula Vista", "Cincinnati", "Clarke County", "Clarksville", "Clearwater", "Cleveland", "College Station", "Colorado Springs", "Columbia", "Columbus", "Concord", "Coral Springs", "Corona", "Corpus Christi", "Costa Mesa", "Dallas", "Daly City", "Danbury", "Davenport", "Davidson County", "Dayton", "Daytona Beach", "Deltona", "Denton", "Denver", "Des Moines", "Detroit", "Downey", "Duluth", "Durham", "El Monte", "El Paso", "Elizabeth", "Elk Grove", "Elkhart", "Erie", "Escondido", "Eugene", "Evansville", "Fairfield", "Fargo", "Fayetteville", "Fitchburg", "Flint", "Fontana", "Fort Collins", "Fort Lauderdale", "Fort Smith", "Fort Walton Beach", "Fort Wayne", "Fort Worth", "Frederick", "Fremont", "Fresno", "Fullerton", "Gainesville", "Garden Grove", "Garland", "Gastonia", "Gilbert", "Glendale", "Grand Prairie", "Grand Rapids", "Grayslake", "Green Bay", "GreenBay", "Greensboro", "Greenville", "Gulfport-Biloxi", "Hagerstown", "Hampton", "Harlingen", "Harrisburg", "Hartford", "Havre de Grace", "Hayward", "Hemet", "Henderson", "Hesperia", "Hialeah", "Hickory", "High Point", "Hollywood", "Honolulu", "Houma", "Houston", "Howell", "Huntington", "Huntington Beach", "Huntsville", "Independence", "Indianapolis", "Inglewood", "Irvine", "Irving", "Jackson", "Jacksonville", "Jefferson", "Jersey City", "Johnson City", "Joliet", "Kailua", "Kalamazoo", "Kaneohe", "Kansas City", "Kennewick", "Kenosha", "Killeen", "Kissimmee", "Knoxville", "Lacey", "Lafayette", "Lake Charles", "Lakeland", "Lakewood", "Lancaster", "Lansing", "Laredo", "Las Cruces", "Las Vegas", "Layton", "Leominster", "Lewisville", "Lexington", "Lincoln", "Little Rock", "Long Beach", "Lorain", "Los Angeles", "Louisville", "Lowell", "Lubbock", "Macon", "Madison", "Manchester", "Marina", "Marysville", "McAllen", "McHenry", "Medford", "Melbourne", "Memphis", "Merced", "Mesa", "Mesquite", "Miami", "Milwaukee", "Minneapolis", "Miramar", "Mission Viejo", "Mobile", "Modesto", "Monroe", "Monterey", "Montgomery", "Moreno Valley", "Murfreesboro", "Murrieta", "Muskegon", "Myrtle Beach", "Naperville", "Naples", "Nashua", "Nashville", "New Bedford", "New Haven", "New London", "New Orleans", "New York", "New York City", "Newark", "Newburgh", "Newport News", "Norfolk", "Normal", "Norman", "North Charleston", "North Las Vegas", "North Port", "Norwalk", "Norwich", "Oakland", "Ocala", "Oceanside", "Odessa", "Ogden", "Oklahoma City", "Olathe", "Olympia", "Omaha", "Ontario", "Orange", "Orem", "Orlando", "Overland Park", "Oxnard", "Palm Bay", "Palm Springs", "Palmdale", "Panama City", "Pasadena", "Paterson", "Pembroke Pines", "Pensacola", "Peoria", "Philadelphia", "Phoenix", "Pittsburgh", "Plano", "Pomona", "Pompano Beach", "Port Arthur", "Port Orange", "Port Saint Lucie", "Port St. Lucie", "Portland", "Portsmouth", "Poughkeepsie", "Providence", "Provo", "Pueblo", "Punta Gorda", "Racine", "Raleigh", "Rancho Cucamonga", "Reading", "Redding", "Reno", "Richland", "Richmond", "Richmond County", "Riverside", "Roanoke", "Rochester", "Rockford", "Roseville", "Round Lake Beach", "Sacramento", "Saginaw", "Saint Louis", "Saint Paul", "Saint Petersburg", "Salem", "Salinas", "Salt Lake City", "San Antonio", "San Bernardino", "San Buenaventura", "San Diego", "San Francisco", "San Jose", "Santa Ana", "Santa Barbara", "Santa Clara", "Santa Clarita", "Santa Cruz", "Santa Maria", "Santa Rosa", "Sarasota", "Savannah", "Scottsdale", "Scranton", "Seaside", "Seattle", "Sebastian", "Shreveport", "Simi Valley", "Sioux City", "Sioux Falls", "South Bend", "South Lyon", "Spartanburg", "Spokane", "Springdale", "Springfield", "St. Louis", "St. Paul", "St. Petersburg", "Stamford", "Sterling Heights", "Stockton", "Sunnyvale", "Syracuse", "Tacoma", "Tallahassee", "Tampa", "Temecula", "Tempe", "Thornton", "Thousand Oaks", "Toledo", "Topeka", "Torrance", "Trenton", "Tucson", "Tulsa", "Tuscaloosa", "Tyler", "Utica", "Vallejo", "Vancouver", "Vero Beach", "Victorville", "Virginia Beach", "Visalia", "Waco", "Warren", "Washington", "Waterbury", "Waterloo", "West Covina", "West Valley City", "Westminster", "Wichita", "Wilmington", "Winston", "Winter Haven", "Worcester", "Yakima", "Yonkers", "York", "Youngstown"
  ],
  adminDepartment: [
    {
      key: 'Zonning',
      value: 1
    },
    {
      key: 'Payroll',
      value: 2
    },
    {
      key: 'Police',
      value: 3
    },
    {
      key: 'Licensing',
      value: 4
    },
    // {
    //   key: 'Police (2nd reviewer)',
    //   value: 4
    // },
  ],

  adminRole: [
    // {
    //   key: 'Super Admin',
    //   value: 1
    // },
    // {
    //   key: 'City Admin',
    //   value: 2
    // },
    // {
    //   key: 'Manager',
    //   value: 3
    // },
    // {
    //   key: 'Clerk',
    //   value: 4
    // },
    // {
    //   key: 'Inspector',
    //   value: 5
    // },
    // {
    //   key: 'Technical review',
    //   value: 6
    // },
    // {
    //   key: 'Final review',
    //   value: 7
    // },
    // {
    //   key: 'Engineer',
    //   value: 8
    // },
    // {
    //   key: 'Assessor',
    //   value: 9
    // },
    // {
    //   key: 'Taxes',
    //   value: 10
    // },
    // {
    //   key: 'Board Member',
    //   value: 11
    // },
    // {
    //   key: 'Alert',
    //   value: 6
    // },
    {
      key: 'Zonning',
      value: 7
    },
    {
      key: 'Payroll',
      value: 8
    },
    {
      key: 'Police (Pre-approval)',
      value: 9
    },
    {
      key: 'Police (Final Approval)',
      value: 10
    },
    {
      key: 'Licensing (Pre-approval)',
      value: 11
    },
    {
      key: 'Licensing (Final Approval)',
      value: 12
    },
    {
      key: 'Clerk',
      value: 13
    },




  ],
  application: {
    status: [
      {
        key: 'Draft',
        value: null, // 0
        name: 'draft'
      },
      {
        key: 'Draft',
        value: 0, // null
        name: 'draft'
      },
      {
        key: 'Accepted',
        value: '3',
        name: 'accepted'
      },
      {
        key: 'Incomplete',
        value: '2', // submitted by user after payment
        name: 'incomplete'
      },

      {
        key: 'Submitted',
        value: '4', // submitted by user after payment
        name: 'submitted'
      },
      {
        key: 'Issue Permit',
        value: '5', // submitted by user after payment
        name: 'issued'
      },
      // {
      //   key: 'Reviewed',
      //   value: '6', // submitted by user after payment
      //   name: 'reviewed'
      // },

      // {
      //   key: 'Accepted',
      //   value: '2', // complete by admin
      //   name: 'accepted'
      // },

      {
        key: 'Approved',
        value: '5', // by admin
        name: 'expire'
      },
      {
        key: 'Denied',
        value: '6', // by admin
        name: 'denied'
      },
      {
        key: 'Issue Permit',
        value: '7', // by admin
        name: 'issued'
      },
      {
        key: 'Ready for Approval',
        value: '10', // by admin
        name: 'Ready for Approval'
      },
      {
        key: 'Reviewed Issued',
        value: '11', // by admin
        name: 'Reviewed Issued'
      },
      {
        key: 'Inspected',
        value: '13', // by admin
        name: 'inspected'
      },
      {
        key: 'Inspection Scheduled',
        value: '12',
        name: 'inspection_scheduled'
      },
    ],
  },


  twApplication: {
    status: [
      {
        key: 'Draft',
        value: null, // 0
        name: 'draft'
      },
      {
        key: 'Draft',
        value: 1, // null
        name: 'draft'
      },
      // {
      //   key: 'Complete',
      //   value: '1', // complete  by user
      //   name: 'complete'
      // },
      {
        key: 'Incomplete',
        value: '2', // submitted by user after payment
        name: 'incomplete'
      },
      {
        key: 'Accepted',
        value: '3', // complete by admin
        name: 'accepted'
      },
      {
        key: 'Submitted',
        value: '4', // submitted by user after payment
        name: 'submitted'
      },
      {
        key: 'Approved',
        value: '5', // by admin
        name: 'approved'
      },
      {
        key: 'Denied',
        value: '6', // by admin
        name: 'denied'
      },
      {
        key: 'Pass',
        value: '7', // by admin
        name: 'pass'
      },
      {
        key: 'Fail',
        value: '8', // by admin
        name: 'fail'
      },
      {
        key: 'Pending',
        value: '9', // by admin
        name: 'pending'
      },
      {
        key: 'Scheduled',
        value: '10', // by admin
        name: 'schedule'
      },
    ],
  },

  alaramApplication: {
    status: [
      {
        key: 'Draft',
        value: null, // 0
        name: 'draft'
      },
      {
        key: 'Draft',
        value: 0, // null
        name: 'draft'
      },
      {
        key: 'Complete',
        value: '1', //  by user
        name: 'complete'
      },
      {
        key: 'Incomplete',
        value: '2', // by admin
        name: 'incomplete'
      },
      {
        key: 'Accepted',
        value: '3', // complete by admin
        name: 'accepted'
      },
      {
        key: 'Submitted',
        value: '4', // submitted by user after payment
        name: 'submitted'
      },
      {
        key: 'Issued',
        value: '5', // by admin
        name: 'issued'
      },
    ],
  },
  cannbisApplication: {
    status: [
      {
        key: 'Draft',
        value: null, // 0
        name: 'draft'
      },
      {
        key: 'Draft',
        value: 0, // null
        name: 'draft'
      },
      {
        key: 'Draft',
        value: '1', // complete  by user
        name: 'draft'
      },
      {
        key: 'Submitted',
        value: '2', // submitted by user after payment
        name: 'submitted'
      },
      {
        key: 'Accepted',
        value: '3', // complete by admin
        name: 'accepted'
      },
      {
        key: 'Incomplete',
        value: '4', // submitted by user after payment
        name: 'incomplete'
      },
      {
        key: 'Approved',
        value: '5', // by admin
        name: 'approved'
      },
      {
        key: 'Denied',
        value: '6', // by admin
        name: 'denied'
      },
    ],
  },




  // 0: "Draft", // or null

  //       1: "Completed", //  or Completed by user

  //       2: "Incomplete", // by admin

  //       3: "Completed", // by admin

  //       4: "Submitted", //  or Submitted by user after payment

  //       5: "Issue Permit", // by admin deci

  subUnitList: {
    unit: [
      {
        key: 'Machines',
        value: '1',
      },
      {
        key: 'Trucks',
        value: '2',
      },
      {
        key: 'Vehicles',
        value: '3',
      },
      {
        key: 'Square Feet',
        value: '4',
      }
    ],
  },


  ach: {
    country: 'US',
    currency: 'usd',
    account_holder_type: 'individual',
  },

  submission: {
    status: [
      {
        key: 'Accept',
        value: 3
      },
      {
        key: 'Incomplete',
        value: 2
      },
    ]
  },

  licensedStaff: {
    licensedStaffList: [
      {
        key: "Safe Serve",
        value: "1"
      },
      {
        key: "CDL",
        value: "2"
      }

    ]
  },

  feeAndPayment: {
    paymentType: [
      {
        key: 'Application',
        value: 0
      },
      {
        key: 'Registration',
        value: 1
      },
      {
        key: 'Permit',
        value: 2
      },
      {
        key: 'License',
        value: 3
      },
      {
        key: 'Processing',
        value: 4
      },
      {
        key: 'Fire',
        value: 5
      }
    ],
    feeType: [
      {
        key: 'Initial',
        value: 0
      },
      {
        key: 'Standard',
        value: 1
      },
      {
        key: 'Micro',
        value: 2
      },
      {
        key: 'Processing',
        value: 3
      },
    ],
  },

  payment: {
    status: [
      {
        key: 'Not Paid',
        value: null
      },
      {
        key: 'Not Paid',
        value: 0
      },
      {
        key: 'Pending',
        value: 1
      },
      {
        key: 'Failed',
        value: 2
      },
      {
        key: 'Success',
        value: 3
      },
      {
        key: 'Waived Off',
        value: 4
      },
      {
        key: 'Void',
        value: 5
      },
    ]
  },

  what: {
    typeOfWhat: [
      {
        key: 'New',
        value: 1
      },
      {
        key: 'Renewal',
        value: 2
      }
    ],
    isBusinessLicense: [
      {
        key: 'Yes',
        value: 1
      },
      {
        key: 'No',
        value: 2
      },
    ]
  },


  documents: {
    essential: [
      'Corporate formation document',
      'EIN confirmation letter',
      'Assumed name registration',
      'Operating agreement',
      'Statement of financial capability',
      'Lease/lease contract/property deed',
      'Location map',
      'Certificate of occupancy',
      'Affidavit of owner consent',
      'Written consent for municipal inspections',
      'Zoning determination',
      'Documents provided to state for state license'
    ],
    bonusPoints: [
      'Evidence majority owner is a minority',
      'Evidence majority owner is a Newark resident',
      'Evidence majority owner was formerly incarcerated for marijuana'
    ]
  },
  getKeysByName(formType, formField, formFieldValue) {
    let key = ''
    if (formField != '') {
      settingConfig[formType][formField].forEach(ele => {
        if (ele.value == formFieldValue) {
          key = ele.key;
        }
      });
      return key;
    } else if (formField == '') {
      settingConfig[formType].forEach(ele => {
        if (ele.value == formFieldValue) {
          key = ele.key;
        }
      });
      return key;
    }
  }

}


